// config value that determines product name and user type
export const PERSONAS = {
  CONSUMER: 'consumer',
  AGENT: 'agent',
  EMPLOYED_USER: 'employed_user'
};

export const DEFAULT_LOCALE = 'en-US';
export const DEFAULT_SITE_TITLE = 'ProviderMatch';

export const MODULES = {
  SEARCH_MATCH: 'search_match',
  MAP_SEARCH: 'map_search',
  DIRECT_BOOK: 'direct_book',
  LOCATIONS: 'locations',
  CRM_INTEGRATION: 'crm_integration',
  AUTHENTICATION: 'authentication',
  PROFILE: 'profile',
  VISIBILITY_AGENT: 'visibility_agent',
  REFERRAL: 'referral'
};

export const CONFIG_ERROR = {
  UNSUPPORTED_KEY: 'UNSUPPORTED_KEY',
  UNSUPPORTED_MODULE: 'UNSUPPORTED_MODULE',
  INVALID_LOCALE: 'INVALID_LOCALE',
  CERNER_INTEGRATION_MISSING_DB_ROUTE_TO:
    'CERNER_INTEGRATION_MISSING_DB_ROUTE_TO'
};

// map APP_ENVIRONMENT to default tealium env to use for that app environment
export const TEALIUM_ENVS = {
  development: 'dev',
  staging: 'stg',
  production: 'prd',
  default: 'dev' // fallback for non-match
};

export const DATADOG = {
  // default disabled. Flip this to enable rum by default for all customers
  RUM_ENABLED: false,
  RUM_SESSION_SAMPLE_RATE: 15,
  // rum_session_replay_sample_rate is a percentage of rum_session_sample_rate
  RUM_SESSION_REPLAY_SAMPLE_RATE: 20
};

export const CERNER_SMART_ON_FHIR_INTEGRATION_KEY = 'cerner';
export const MYCHART_EMBEDDED_SMART_ON_FHIR_INTEGRATION_KEY =
  'mychart_embedded';

// by default in customer-service, on the customer-service api level,
// each actor config will inherit from 'global' only if the field does not exist
// in the customer specific config. fields in this list will get deep-merged
// from the global config even if the actor-specific config already defines the fields.
export const GLOBAL_CONFIG_MERGE_FIELDS = [
  'feature_flags',
  'darkship_feature_flags',
  'mfe_versions',
  'datadog'
];

export const configFieldWhitelistClient = [
  'active_modules',
  'alternate_providers',
  'application_string_templates',
  'crm',
  'darkship_display_providers_on_locations_page',
  'darkship_feature_flags',
  'darkship_KENG_31725',
  'darkship_use_list_page_searchv9',
  'darkship_use_profile_searchv9',
  'datadog',
  'display_availability_in_search',
  'domains',
  'emergency_disclaimer',
  'emergency_disclaimer_md',
  'facets',
  'facets_v9',
  'feature_flags',
  'google_configuration',
  'gxv2_enabled',
  'hide_availability_density',
  'host',
  'image_service',
  'index',
  'insurance_disclaimer',
  'insurance_information_link_href',
  'KENG_38276_show_search_suggestions_v9',
  'locale',
  'locale_domains',
  'location_facet',
  'maps_config',
  'mfe_versions',
  'logging_metadata',
  'logos',
  'logos_v9',
  'minimum_appointment_purposes_for_filter',
  'modal_display',
  'og_image',
  'patient_search_refiner',
  'persona',
  'provider_list_default_view',
  'provider_tile',
  'provider_v9',
  'provider',
  'search_alerts',
  'search_home',
  'search_params',
  'search_results_page',
  'search_results_page_v9',
  'search_widget',
  'seo',
  'show_dbw_appt_time_alt_providers',
  'show_powered_by_kyruus_logo',
  'show_provider_profile_alt_providers',
  'skip_db_enablement_check',
  'social_share',
  'sort_options',
  'tealium',
  'theme',
  'third_party',
  'referral'
];

export const LIST_VIEW_MODE = {
  LIST: 'list',
  GRID: 'grid',
  MODERN_GRID: 'modern-grid'
};
